import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AlertService } from '../../../services/alert/alert.service';
import { FileService, StoredFile } from '../../../services/file/file.service';
import { WancomHttpService } from '../../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../../../features/layout/waiting/waiting.service';
import { FileUploadModule } from 'ng2-file-upload';
import { debounceTime } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-upload-file-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        FileUploadModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './upload-file-dialog.component.html',
    styleUrl: './upload-file-dialog.component.scss'
})
export class UploadFileDialogComponent implements OnInit {
    //#region Variables
    public title: string = "Déposez votre fichier ici";

    /** Uploader et fichiers **/
    /**
     * File Service
     */
    public fileUploadService: FileService = new FileService(this.wncmHttp$);
    /**
     * extensions acceptées pour l'uploader de fichiers
     */
    public fileExtensionAccepted: string =
        '.png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.mp4,.MP4,.gif,.GIF';
    /**
     * Permet de changer le style au survol du drag&drop file
     */
    public isHoveringUploader: boolean = false;
    /**
     * Loader du fichier
     */
    public isfileLoading: boolean = false;
    /**
     * fichier uploadé par l'utilisateur
     */
    public uploadedStoredFile?: StoredFile = null;
    private waitingId: string = null;

    //#endregion Variables

    // MARK: CONSTRUCTOR
    constructor(
        private readonly alert$: AlertService,
        private readonly wncmHttp$: WancomHttpService,
        private readonly waiting$: WaitingService,
        private readonly dialogRef: MatDialogRef<UploadFileDialogComponent>,
    ) {

    }

    ngOnInit(): void {
        this.initFileService();
    }

    private initFileService() {
        this.fileUploadService.falseFile
            .pipe(debounceTime(500))
            .subscribe(() => {
                this.waiting$.end(this.waitingId);

                this.alert$.show({
                    message: "Erreur, le fichier importé n'est pas une image",
                    duration: 2000,
                });

                this.isfileLoading = false;
            });

        this.fileUploadService.fileSaved.subscribe(
            (savedStoredFile: StoredFile) => {
                //stop loading server
                this.waiting$.end(this.waitingId);

                this.uploadedStoredFile = savedStoredFile;

                //stop loading front
                this.isfileLoading = false;
            }
        );
    }

    fileAdded() {
        //Start loading
        this.waitingId = this.waiting$.start();

        this.isfileLoading = true;
    }

    fileOverUploader(e: any) {
        this.isHoveringUploader = e;
    }


    getSrc(sf: StoredFile) {
        return `${environment.apiBaseUrl}/file/getFile/${sf.storageId}/${sf.fileName}`;
    }

    validUpload() {
        this.dialogRef.close(this.uploadedStoredFile);
    }
}
